module.exports = __webpack_public_path__ + "img/pic2.1009e176.png";